import t from"styled-components";const e=t.div`
	display: grid;
	place-content: center;
	width: 100%;
	height: 100%;
`;t.div`
	width: 48px;
	height: 48px;
	border-radius: 48px;

	margin-bottom: 4px;
`;const i=t.img`
	width: 48px;
	height: 48px;
	border-radius: 48px;

	margin-bottom: 4px;
	object-fit: cover;
`,o=t.span`
	text-align: center;
	color: ${({color:t})=>t};
	font-size: 16px;
	line-height: 18px;
	min-height: 18px;
	font-weight: 500;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
`,n=t.p`
	all: unset;
	color: ${({color:t})=>t};
	text-align: center;
	font-size: 12px;
	min-height: 14px;
	font-weight: 400;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
`,l=t.h2`
	all: unset;
	color: ${({color:t})=>t};
	text-align: center;
	font-size: ${({isTemplate:t})=>t?"10px":"14px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:t})=>t?"12px":"19px"};
`,r=t.div`
	border-radius: 100px;
	background: ${({backgroundColor:t,theme:e})=>t||e.border.black10};
	display: flex;
	padding: ${({isTemplate:t})=>t?" 3.699px 7.399px":"5px 10px"};

	justify-content: center;
	align-items: center;

	color: ${({color:t,theme:e})=>t||e.text.title};
	font-size: ${({isTemplate:t})=>t?"9px":"12px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:t})=>t?"9px":"16px"};
`,p=t.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
`;t.div`
	width: 24px;
	height: 24px;
	display: grid;
	place-content: center;

	cursor: pointer;

	position: absolute;

	${({position:t})=>"bottom"===t?"\n        left: calc(50% - 12px);\n        bottom: -12px;\n      ":"right"===t?"\n        top: 8px;\n        right: -12px;\n      ":void 0}

	svg, circle, path {
		transition: color 100ms linear, fill 100ms linear;
	}

	&:hover {
		.delete-action {
			circle {
				fill: #ff5630;
			}
			path {
				fill: #fff;
			}
		}

		svg {
			color: #00afff !important;
			fill: #fff !important;
		}
	}
`;const c=t.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 24px;
`,a=t.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-width: 100%;
`;export{c as CardContent,a as CardDetails,n as Info,r as Label,o as Name,l as PeopleSubtitle,e as SpinnerContainer,p as TextColumnWrapper,i as UserImage};
